var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "password",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.624,
    height: 20.142,
    viewBox: "0 0 17.624 20.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 0.801,
    cy: 0.801,
    r: 0.801,
    transform: "translate(12.518 12.775)",
    fill: "#1077bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M48.837,14.241a.787.787,0,0,0,.787-.787V10.543A3.151,3.151,0,0,0,46.477,7.4h-.946V4.621a4.722,4.722,0,0,0-9.442,0V7.4h-.943A3.151,3.151,0,0,0,32,10.543v6.452a3.151,3.151,0,0,0,3.147,3.147h11.33a3.151,3.151,0,0,0,3.147-3.147.787.787,0,1,0-1.574,0,1.575,1.575,0,0,1-1.574,1.574H35.147a1.575,1.575,0,0,1-1.574-1.574V10.543a1.575,1.575,0,0,1,1.574-1.574h11.33a1.575,1.575,0,0,1,1.574,1.574v2.911A.787.787,0,0,0,48.837,14.241ZM43.958,7.4H37.663V4.621a3.149,3.149,0,0,1,6.294,0Z",
    transform: "translate(-32)",
    fill: "#1077bb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 0.751,
    cy: 0.801,
    rx: 0.751,
    ry: 0.801,
    transform: "translate(6.609 12.775)",
    fill: "#1077bb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 0.801,
    cy: 0.801,
    r: 0.801,
    transform: "translate(3.604 12.775)",
    fill: "#1077bb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 0.801,
    cy: 0.801,
    r: 0.801,
    transform: "translate(9.513 12.775)",
    fill: "#1077bb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.4a8dff25bebe572ce950e6490557ab34.svg";
export { ForwardRef as ReactComponent };